/* Moves the real buy area (native ATC + Shiprocket headless button + dynamic
   checkout) into the PM hero slot, then hides the theme product section.

   Two rules that matter:
   1. The host section is resolved ONCE, before anything moves. After the move the
      product form lives inside the hero, so re-resolving would return the hero
      itself and hide it.
   2. Never hide a section that contains the hero. */
(function () {
  var CSS = [
    '[data-pmh-slot] .product-form-wrapper{width:100%;}',
    '[data-pmh-slot] form.product-form{display:grid!important;gap:10px!important;margin:0!important;}',
    '[data-pmh-slot] .product-form__buttons{display:grid!important;gap:10px!important;margin:0!important;}',
    '[data-pmh-slot] .buy-buttons{display:grid!important;gap:10px!important;width:100%!important;flex-wrap:nowrap!important;}',
    '[data-pmh-slot] .shiprocket-headless{width:100%!important;display:block!important;}',
    '[data-pmh-slot] .shiprocket-headless button,[data-pmh-slot] .shiprocket-headless a{width:100%!important;}',
    '[data-pmh-slot] [name="add"],[data-pmh-slot] .product-form__submit{width:100%!important;min-width:0!important;min-height:0!important;flex:none!important;background:#1B4D42!important;color:#fff!important;border:none!important;border-radius:8px!important;padding:16px 24px!important;font-family:Inter,sans-serif!important;font-size:15px!important;font-weight:500!important;letter-spacing:0!important;text-transform:none!important;line-height:1.3!important;}',
    '[data-pmh-slot] [name="add"]:hover,[data-pmh-slot] .product-form__submit:hover{background:#2A6E60!important;}',
    '[data-pmh-slot] .shopify-payment-button__button{border-radius:8px!important;min-height:52px!important;}',
    '[data-pmh-slot] .product-form__alert[hidden]{display:none!important;}'
  ].join('');

  function injectCss() {
    if (document.getElementById('pm-adopt-css')) { return; }
    var s = document.createElement('style');
    s.id = 'pm-adopt-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function boot() {
    injectCss();
    var roots = document.querySelectorAll('[data-pm-adopt]');
    for (var i = 0; i < roots.length; i++) { start(roots[i]); }
  }

  function start(root) {
    var sid = root.getAttribute('data-pm-adopt');
    var dataEl = document.querySelector('[data-pmh-data="' + sid + '"]');
    var cfg = {};
    try { cfg = JSON.parse(dataEl.textContent); } catch (e) { cfg = {}; }

    var slot = root.querySelector('[data-pmh-slot]');
    if (!slot || cfg.adopt === false) { return; }

    function PM() { return window.PMCheckout; }

    /* Resolve the host section ONCE, while the form is still inside it. */
    var hostEl = (function () {
      var f = document.querySelector('form[action*="/cart/add"]');
      var s = (f && f.closest) ? f.closest('[id^="shopify-section-"]') : null;
      if (!s) { s = document.querySelector('[id^="shopify-section-"][id*="main-product"]'); }
      if (s && s.contains(root)) { return null; }
      return s;
    })();

    if (!hostEl) {
      root.setAttribute('data-pm-adopt-state', 'no-product-section');
      return;
    }

    function pickBuyArea() {
      var f = hostEl.querySelector('form[action*="/cart/add"]');
      if (!f || slot.contains(f)) { return null; }
      return f.closest('.product-form-wrapper') || f;
    }

    function relabelNative() {
      if (!cfg.relabel || !cfg.label) { return; }
      var btn = slot.querySelector('[name="add"]') || slot.querySelector('.product-form__submit');
      if (!btn) { return; }
      var leaves = btn.querySelectorAll('span, div');
      for (var i = 0; i < leaves.length; i++) {
        var el = leaves[i];
        if (el.children.length === 0 && el.textContent.trim().length > 0) { el.textContent = cfg.label; return; }
      }
      for (var j = 0; j < btn.childNodes.length; j++) {
        var cn = btn.childNodes[j];
        if (cn.nodeType === 3 && cn.nodeValue.trim()) { cn.nodeValue = cfg.label; return; }
      }
      btn.textContent = cfg.label;
    }

    var hidden = false;
    function hideHost() {
      if (hidden || cfg.hide === false) { return; }
      if (!hostEl || hostEl.contains(root)) { return; }
      var s = hostEl.style;
      s.setProperty('position', 'absolute', 'important');
      s.setProperty('left', '-9999px', 'important');
      s.setProperty('top', '0', 'important');
      s.setProperty('width', '640px', 'important');
      s.setProperty('opacity', '0', 'important');
      s.setProperty('pointer-events', 'none', 'important');
      s.setProperty('z-index', '-1', 'important');
      hidden = true;
    }

    function adopt() {
      var area = pickBuyArea();
      if (area) { slot.appendChild(area); }

      if (!slot.querySelector('form, .buy-buttons, [name="add"]')) { return false; }

      slot.classList.add('adopted');
      relabelNative();

      if (PM()) {
        var fx = PM().findFastrr(slot);
        var real = fx || PM().findNative(slot);
        if (real) { PM().setPrimary(real); }
        var selected = root.querySelector('[data-pmh-var].on');
        PM().setVariant(selected ? selected.getAttribute('data-pmh-var') : cfg.variantId);
        root.setAttribute('data-pm-adopt-state', fx ? 'checkout-app' : 'native-only');
      }

      hideHost();
      return true;
    }

    [0, 150, 400, 900, 1800, 3200, 5000, 7500].forEach(function (d) { setTimeout(adopt, d); });
    window.addEventListener('load', adopt);

    if (window.MutationObserver) {
      new MutationObserver(function () { adopt(); }).observe(hostEl, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); }
  else { boot(); }
})();
